import { FC } from 'react';
import { Box, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { Document, Page, Text, View } from '@react-pdf/renderer';
import { FactsheetPreview } from '../PdfPreview';

interface PdfPreviewDialogProps {
  open: boolean;
  onClose: () => void;
  data: any;
  template?: any;
  title?: string;
}

/** Stub kept for PDFViewerV2 registry typing. P&R PDFs are generated server-side. */
export const FactsheetPDF: FC<{ data?: any }> = () => (
  <Document>
    <Page size="A4">
      <View>
        <Text>P&R Real Value</Text>
      </View>
    </Page>
  </Document>
);

export const PdfPreviewDialog: FC<PdfPreviewDialogProps> = ({ open, onClose, data, template, title }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg" PaperProps={{ sx: { height: '90vh' } }}>
    <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <span>{title || 'P&R Real Value — Preview'}</span>
      <IconButton onClick={onClose}>
        <Close />
      </IconButton>
    </DialogTitle>
    <DialogContent sx={{ p: 2, bgcolor: '#f3f4f6', overflowY: 'auto' }}>
      <Box sx={{ maxWidth: 900, mx: 'auto' }}>
        <FactsheetPreview data={data} template={template} />
      </Box>
    </DialogContent>
  </Dialog>
);
